
import React from 'react';

const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Free Consultation',
    description:
      "Call us or fill out our form. We'll discuss your needs and schedule a convenient time for an on-site inspection.",
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'Detailed Inspection',
    description:
      'Our certified team performs a thorough inspection of your roof and exterior, documenting every detail with photos.',
  },
  {
    number: '03',
    icon: 'ri-file-list-3-line',
    title: 'Custom Proposal',
    description:
      "You'll receive a transparent, itemized estimate with material options, timelines, and financing if needed.",
  },
  {
    number: '04',
    icon: 'ri-hammer-line',
    title: 'Expert Installation',
    description:
      'Our skilled crews complete the work on schedule with premium materials, leaving your property spotless.',
  },
];

export default function ServiceProcess() {
  return (
    <section className="py-24 bg-matte-black relative z-10 overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img
          src="https://static.readdy.ai/image/69b3c4875e1562fa68a140ce2d237389/644ca808ee069ab97d6a9bc1f4617fe7.png"
          alt=""
          className="w-[700px] h-auto opacity-[0.04]"
        />
      </div>

      <div className="max-w-7xl mx-auto px-8 lg:px-16 relative z-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-2 h-2 rounded-full bg-neon-green"></div>
            <span className="text-xs uppercase tracking-widest font-medium text-gray-400">
              How It Works
            </span>
            <div className="w-2 h-2 rounded-full bg-neon-green"></div>
          </div>
          <h2
            className="text-4xl lg:text-5xl font-bold text-white mb-4"
            style={{
              fontFamily: "'Bebas Neue', sans-serif",
              letterSpacing: '0.04em',
            }}
          >
            Our Simple <span className="text-neon-green">4-Step</span> Process
          </h2>
          <p className="text-base text-gray-400 max-w-xl mx-auto">
            From your first call to the final walkthrough, we make every step
            easy and stress‑free.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step) => (
            <div
              key={step.number}
              className="relative bg-gunmetal/60 rounded-xl p-7 border border-gray-700/50 hover:border-neon-green/40 transition-all duration-300 group"
            >
              <span
                className="text-5xl font-black text-neon-green/10 absolute top-4 right-5"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                {step.number}
              </span>
              <div className="w-12 h-12 flex items-center justify-center bg-neon-green/10 rounded-lg mb-5 group-hover:bg-neon-green/20 transition-colors">
                <i className={`${step.icon} text-neon-green text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                {step.description}
              </p>
              {step !== steps[steps.length - 1] && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                  <i className="ri-arrow-right-s-line text-neon-green/40 text-2xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
